<template>
    <div class="tsa-confirmV2-Dialog" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <p class="close el-icon-close" @click="close"></p>
            <div class="top">
                <img v-if="type" :src="iconStyle[type]" alt="">
                <p>{{ title }}</p>
            </div>
            <div class="center">
                <p v-html="message"></p>
            </div>
            <div class="btn-group">
                <div class="btn">
                    <TsaButton plain @click="cancel" type="default" size="small">{{ cancelButtonText }}</TsaButton>
                </div>
                <div class="btn">
                    <TsaButton :loading="loading" @click="confirm" size="small" backGroundColor="linear-gradient( 90deg, #164FF9 0%, #1870FF 100%)">{{ confirmButtonText }}</TsaButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TsaButton from '@/components/copyright/basics/button'
import TsaDialogV2 from '@/components/copyright/basics/dialogV2'
export default {
    components: {
        TsaButton,
        TsaDialogV2
    },
    data () {
        return {
            show: false,
            title: '',
            message: '',
            type: '', // warn success
            loading: false,
            cancelButtonText: '',
            confirmButtonText: '',
            iconStyle: {
                'warn': require('@/assets/images/dialog/warn.png'),
                'success': require('@/assets/images/dialog/success.png')
            }
        }
    },
    watch: {
        show (val) {
            if (!val) {
                setTimeout(() => {
                    this.onClose = null
                    this.onCancel = null
                    this.onOpen = null
                    this.onConfirm = null
                    this.loading = false
                }, 200)
            }else {
                this.$nextTick(() => {
                    this.onOpen && this.onOpen(this)
                })
            }
        }
    },
    methods: {
        close () {
            if (this.onClose) {
                this.onClose && this.onClose(this)
            } else {
                this.show = false
            }
            
        },
        cancel () {
            if (this.onCancel) {
                this.onCancel && this.onCancel(this)
            } else {
                this.show = false
            }
        },
        confirm () {
            if (this.onConfirm) {
                this.onConfirm && this.onConfirm(this)
            } else {
                this.show = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-confirmV2-Dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .5);
        }
        .content {
            width:calc(100% - 24px);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #FFFFFF;
            box-shadow: 0px 4px 12px 1px rgba(7,12,20,0.12);
            border-radius: 12px;
            padding: 16px;
            padding-top: 38px;
            box-sizing: border-box;
            .close {
                position: absolute;
                top: 15px;
                right: 15px;
                font-size: 20px;
                color: #999999;
                cursor: pointer;
                &:hover {
                    color: #2468F2;
                }
            }
            .top {
                display: flex;
                align-items: center;
                margin-bottom: 4px;
                img {
                    width: 32px;
                    height: 32px;
                    margin-right: 8px;
                }
                p {
                    font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }
            }
            .center {
                padding-left: 40px;
                margin-bottom: 28px;
                p {
                    font-size: 16px;
                    color: #333333;
                }
            }
            .btn-group {
                display: flex;
                justify-content: flex-end;
                .btn {
                    width: 98px;
                    margin-left: 12px;
                }
            }
        }
    }
</style>